import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Button, ButtonGroup, Form, FormGroup, Label, Input } from 'reactstrap';
import Select from 'react-select';
import { updateLoggedUser } from '../../actions/api';
import Icon from '../../components/Icon';
import { VCS, VCS_SLUG, resolveVcs, VCS_LINK, USER_INFO_TYPES } from '../../constants/api';
import * as types from '../../constants/ActionTypes';
import { IS_APP_CODEAC } from '../../constants/env';
import timezones, { UTC_TIMEZONE_ID } from '../../constants/timezones';
import { getScheme, setScheme } from '../../utils/colorScheme';
const timezonesById = Object.assign({}, ...timezones.map((value) => ({
    [value.value]: value,
})));
class ProfileForm extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            email: '',
            timezoneId: null,
            storing: false,
            scheme: getScheme(),
        };
        this.handleChangeEmail = (email) => {
            return this.setState({ email: email });
        };
        this.handleChangeTimezoneId = (value) => {
            return this.setState({ timezoneId: value.value });
        };
        this.handleSubmit = (event) => {
            event.preventDefault();
            if (!this.emailRef || !this.emailRef.validity.valid) {
                return;
            }
            this.setState({ storing: true });
            const data = {
                email: this.state.email,
                timezoneId: this.state.timezoneId,
            };
            this.props.dispatch(updateLoggedUser(data)).then((action) => {
                if (action.type === types.UPDATE_LOGIN_USER_DETAILS_SUCCESS) {
                    this.props.dispatch({
                        type: types.LOGGED_USER,
                        payload: action.response.data,
                    });
                    this.setState({ storing: false });
                }
                else {
                    console.error(action);
                }
            });
        };
        this.handleSchemeChange = (scheme) => {
            setScheme(scheme);
            this.setState({ scheme });
        };
    }
    UNSAFE_componentWillReceiveProps(props) {
        if (!this.state.email && props.user.user && props.user.user.email) {
            return this.setState({
                email: props.user.user.email,
                timezoneId: props.user.user.timezoneId,
            });
        }
    }
    render() {
        const { user, t } = this.props;
        const { scheme } = this.state;
        if (!user.user) {
            return null;
        }
        const vcsSlug = resolveVcs(VCS_SLUG[user.user.vcs]);
        let profileLink, profileText;
        switch (vcsSlug) {
            case VCS_SLUG[VCS.BITBUCKET]:
                profileLink = VCS_LINK[user.user.vcs] + '/account/user/' + user.user.username + '/';
                profileText = 'settings.bitbucketProfile';
                break;
            case VCS_SLUG[VCS.GITHUB]:
                profileLink = VCS_LINK[user.user.vcs] + '/settings/profile';
                profileText =
                    user.user.emailType === USER_INFO_TYPES.GITHUB_CUSTOM_EMAIL
                        ? 'settings.githubWithoutEmailProfile'
                        : 'settings.githubProfile';
                break;
            case VCS_SLUG[VCS.GITLAB]:
                profileLink = VCS_LINK[user.user.vcs] + '/-/user_settings/profile';
                profileText = 'settings.gitlabProfile';
                break;
        }
        return (_jsx("div", { className: "container", children: _jsxs("div", { className: "row", children: [_jsx("div", { className: "col col-12 col-md-9 order-1 order-md-0", children: _jsxs(Form, { onSubmit: this.handleSubmit, children: [_jsxs(FormGroup, { children: [_jsx(Label, { for: "displayName", children: t('settings.displayName') }), _jsx(Input, { type: "text", name: "displayName", id: "displayName", value: user.user.displayName, disabled: true })] }), _jsxs(FormGroup, { children: [_jsx(Label, { for: "email", children: t('settings.email') }), _jsx(Input, { type: "email", name: "email", id: "email", innerRef: (emailRef) => (this.emailRef = emailRef), value: this.state.email, onChange: (event) => this.handleChangeEmail(event.target.value), disabled: vcsSlug !== VCS_SLUG[VCS.BITBUCKET] &&
                                                (vcsSlug !== VCS_SLUG[VCS.GITHUB] ||
                                                    user.user.emailType !== USER_INFO_TYPES.GITHUB_CUSTOM_EMAIL) })] }), _jsxs(FormGroup, { children: [_jsx(Label, { for: "timezone", children: t('settings.timezone') }), _jsx(Select, { classNamePrefix: "react-select", id: "timezone", value: timezonesById[this.state.timezoneId || UTC_TIMEZONE_ID], onChange: this.handleChangeTimezoneId, options: timezones })] }), IS_APP_CODEAC && user.user?.experimentalFeatures && (_jsxs(FormGroup, { children: [_jsx("div", { children: _jsx(Label, { children: t('settings.colorTheme') }) }), _jsxs(ButtonGroup, { children: [_jsx(Button, { color: "secondary", outline: true, onClick: () => this.handleSchemeChange('auto'), active: scheme === 'auto', children: t('settings.theme.light') }), _jsx(Button, { color: "secondary", outline: true, onClick: () => this.handleSchemeChange('dark'), active: scheme === 'dark', children: t('settings.theme.dark') })] })] })), _jsx("div", { className: "text-right mb-2", children: _jsx("a", { href: profileLink, target: "_blank", rel: "noreferrer", children: t(profileText) }) }), _jsx("div", { className: "text-center text-md-left", children: _jsxs(Button, { type: "submit", disabled: this.state.storing, children: [!this.state.storing ? null : (_jsx(Icon, { name: "spinner", pulse: true, className: "mr-2", fixedWidth: true })), t('settings.updateProfile')] }) })] }) }), _jsxs("div", { className: "col col-12 col-md-3 mb-2 order-0 order-md-1", children: [_jsx("div", { children: t('settings.profilePicture') }), _jsx("img", { src: user.user.bitbucketAvatar || user.user.gitlabAvatar, className: "mw-100" })] })] }) }));
    }
}
const mapStateToProps = (state) => ({
    user: state.user,
});
const mapDispatchToProps = (dispatch) => ({
    dispatch: dispatch,
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ProfileForm));
